import { useEffect, useState } from "react";

const TARGET = new Date("2026-08-01T14:00:00+02:00").getTime();

export const Countdown = () => {
  const [t, setT] = useState(() => TARGET - Date.now());

  useEffect(() => {
    const i = setInterval(() => setT(TARGET - Date.now()), 1000);
    return () => clearInterval(i);
  }, []);

  const clamp = Math.max(t, 0);
  const days = Math.floor(clamp / (1000 * 60 * 60 * 24));
  const hours = Math.floor((clamp / (1000 * 60 * 60)) % 24);
  const mins = Math.floor((clamp / (1000 * 60)) % 60);
  const secs = Math.floor((clamp / 1000) % 60);

  const Item = ({ v, label, testid }) => (
    <div
      data-testid={testid}
      className="flex flex-col items-center min-w-[72px] sm:min-w-[92px]"
    >
      <div className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white tabular-nums leading-none">
        {String(v).padStart(2, "0")}
      </div>
      <div className="mt-2 text-[10px] sm:text-xs uppercase tracking-[0.25em] text-sage-100/90">
        {label}
      </div>
    </div>
  );

  return (
    <div
      data-testid="countdown"
      className="flex items-center justify-center gap-4 sm:gap-8 lg:gap-10 flex-wrap"
    >
      <Item v={days} label="Tage" testid="countdown-days" />
      <span className="text-white/30 text-3xl font-serif">·</span>
      <Item v={hours} label="Stunden" testid="countdown-hours" />
      <span className="text-white/30 text-3xl font-serif">·</span>
      <Item v={mins} label="Minuten" testid="countdown-minutes" />
      <span className="text-white/30 text-3xl font-serif">·</span>
      <Item v={secs} label="Sekunden" testid="countdown-seconds" />
    </div>
  );
};

export default Countdown;
